import React, { Component } from "react";
import { connect } from "react-redux";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ADR_EDIT } from "../../_constants/actionConstants";
import AdrLocTestPerformedRowV3 from "./AdrLocTestPerformedRowV3";

class AdrLocTestsPerformedV3 extends Component {
  handleClick_add = (e) => {
    e.preventDefault();
    const {
      dispatch,
      tabId,
      wpTabId,
      locationWorkPerformed: locWp,
      markAdrDirty,
    } = this.props;
    dispatch({
      type: ADR_EDIT.LOCATION_WORKPERFORMED.TESTS_PERFORMED.ADD,
      tabId,
      wpTabId,
      clientId: locWp.clientId,
    });
    markAdrDirty();
  };

  handleClick_delete = (locTpIndex) => (e) => {
    const {
      dispatch,
      tabId,
      wpTabId,
      locationWorkPerformed: locWp,
      markAdrDirty,
    } = this.props;
    e.preventDefault();
    dispatch({
      type: ADR_EDIT.LOCATION_WORKPERFORMED.TESTS_PERFORMED.DELETE,
      tabId,
      wpTabId,
      clientId: locWp.clientId,
      locTpIndex,
    });
    markAdrDirty();
  };

  render() {
    const {
      idSuffix,
      showLtpBlock,
      toggleLtpBlock,
      locationWorkPerformed: locWp,
      projectId,
      tabId,
      wpTabId,
      status,
      markAdrDirty,
    } = this.props;
    const testsPerformed = locWp.testsPerformed || [];

    return (
      <div className="locwp-row-tp">
        <div className="card mb-2 w-100 bg-lightblue">
          <div className="card-body p-2">
            <label
              id={`ltpToggler_${idSuffix}`}
              className="mb-0 loc-wp-subsection-toggler"
              onClick={() => toggleLtpBlock(idSuffix)}
            >
              <FontAwesomeIcon
                icon={showLtpBlock ? "caret-down" : "caret-right"}
                className="fa-fw mr-1"
              />
              <b>
                <i>Field Tests Performed</i>
              </b>
              <span className="badge badge-pill badge-danger my-auto ml-2">
                {testsPerformed && testsPerformed.length}
              </span>
            </label>
            <Collapse isOpen={showLtpBlock}>
              <hr className="mb-0 mt-1" />
              <div className="locwp-row-tp__table">
                <div className="locwp-row-tp__tr">
                  <div className="locwp-row-tp__td--test-type">
                    <span>
                      <b>Type of Test</b>
                    </span>
                  </div>
                  <div className="locwp-row-tp__td--count">
                    <span>
                      <b>
                        Count
                        <FontAwesomeIcon icon="info-circle" className="ml-2 mr-4" />
                      </b>
                    </span>
                  </div>
                  <div className="locwp-row-tp__td--remarks">
                    <span>
                      <b>Remarks</b>
                    </span>
                  </div>
                  <div className="locwp-row-tp__td--del"></div>
                </div>
              </div>
              {testsPerformed &&
                testsPerformed.map((locTp, index) => (
                  <AdrLocTestPerformedRowV3
                    key={`locTpRow_${index}`}
                    clientId={locWp.clientId}
                    locTpIndex={index}
                    testPerformed={locTp}
                    handleClick_delete={this.handleClick_delete}
                    isLastRow={testsPerformed.length - 1 === index}
                    projectId={projectId}
                    tabId={tabId}
                    wpTabId={wpTabId}
                    status={status}
                    markAdrDirty={markAdrDirty}
                  />
                ))}
              <hr className="my-2" />
              <button
                type="button"
                name="addLtpRow"
                id={`addLtpRow_${idSuffix}`}
                className="btn btn-outline-secondary"
                onClick={this.handleClick_add}
              >
                Add New Field Test
              </button>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(AdrLocTestsPerformedV3);
